__turbopack_context__.v({
  "editButton": "styles-module__V08LWa__editButton",
  "editableDialog": "styles-module__V08LWa__editableDialog",
  "editableWrapper": "styles-module__V08LWa__editableWrapper",
});
